import { render } from "./DatasetView.vue?vue&type=template&id=8d2bfc6e"
import script from "./DatasetView.vue?vue&type=script&lang=js"
export * from "./DatasetView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/DatasetView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8d2bfc6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8d2bfc6e', __exports__)) {
    api.reload('8d2bfc6e', __exports__)
  }
  
  module.hot.accept("./DatasetView.vue?vue&type=template&id=8d2bfc6e", () => {
    api.rerender('8d2bfc6e', render)
  })

}


export default __exports__